import { cva } from '@/styled-system/css';

export const adornedInputRecipe = cva({
  base: {
    'backgroundColor': {
      base: 'AdornedInput.bg.default',
    },
    'cursor': 'text',
    'boxShadow': {
      base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color)',
    },
    'boxShadowColor': {
      base: 'AdornedInput.border.default',
    },
    'textStyle': 'body',
    '&.edge-autofilled': {
      backgroundColor: { base: 'AdornedInput.bg.default' },
    },
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease, background-color 200ms ease',
    },
    '&:has([data-c11n-component="AdornedInput.Input"] ~ button[data-c11n-component="AdornedInput.Adornment"])':
      {
        paddingInlineEnd: 0,
      },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        '&:has(input:focus-visible), &:active:not(:has(button:active, [role="button"]:active, a:active))':
          {
            backgroundColor: 'bg.neutral',
            boxShadow: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
            boxShadowColor: 'border.action.hero.selected.default',
          },
        'backgroundColor': {
          _hover: 'AdornedInput.bg.hover',
          _active: 'bg.neutral',
          _focus: 'bg.neutral',
        },
        'boxShadowColor': {
          _hover: 'AdornedInput.border.hover',
          _active: 'border.action.hero.selected.default',
          _focus: 'border.action.hero.selected.default',
        },
        '&:is(:hover:active), &:is(:hover:focus)': {
          backgroundColor: 'bg.neutral',
        },
      },
    },
    error: {
      true: {
        'backgroundColor': {
          base: 'AdornedInput.bg.error',
        },
        'boxShadowColor': {
          base: 'AdornedInput.border.error',
        },
        '&:has(input:focus-visible), &:active:not(:has(button:active, [role="button"]:active, a:active))':
          {
            backgroundColor: 'bg.neutral',
            boxShadowColor: 'AdornedInput.border.errorActive',
          },
      },
      false: {},
    },
    fluid: {
      true: {
        display: 'flex',
        width: '100%',
      },
      false: {
        display: 'inline-flex',
        width: 'auto',
      },
    },
    readOnly: {
      true: {
        backgroundColor: {
          base: 'bg.invisible',
        },
        boxShadowColor: 'transparent.invisible',
      },
      false: {},
    },
    size: {
      sm: {
        borderRadius: 'obj.default',
        columnGap: 'tighter',
        paddingInline: 'default',
      },
      md: {
        borderRadius: 'obj.default',
        columnGap: 'tighter',
        paddingInline: 'default',
      },
      lg: {
        borderRadius: 'obj.default',
        columnGap: 'tighter',
        paddingInline: 'default',
      },
    },
  },
  compoundVariants: [
    {
      size: 'sm',
      readOnly: true,
      css: {
        paddingInline: 'none',
      },
    },
    {
      size: 'md',
      readOnly: true,
      css: {
        paddingInline: 'none',
      },
    },
    {
      size: 'lg',
      readOnly: true,
      css: {
        paddingInline: 'none',
      },
    },
    {
      readOnly: true,
      disabled: false,
      css: {
        backgroundColor: {
          _active: 'bg.invisible',
          _focusWithin: 'bg.invisible',
          _hover: 'bg.invisible',
        },
        boxShadowColor: 'transparent.invisible',
      },
    },
    {
      error: true,
      disabled: false,
      css: {
        'backgroundColor': {
          _hover: 'AdornedInput.bg.errorHover',
          _active: 'bg.neutral',
        },
        'boxShadowColor': {
          _active: 'AdornedInput.border.errorActive',
          _hover: 'AdornedInput.border.errorHover',
        },
        '&:is(:hover:active)': {
          backgroundColor: 'bg.neutral',
        },
      },
    },
  ],
});
